let loadPromise;

const hideRecaptchaBadge = () => {
    const styleId = 'cc-recaptcha-badge-style';
    if (document.getElementById(styleId)) { return; }
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = '.grecaptcha-badge { visibility: hidden !important; }';
    document.head.appendChild(style);
};

export const loadRecaptcha = (v3SiteKey = '') => {
    hideRecaptchaBadge();
    if (window.grecaptcha) {
        return new Promise((resolve) => window.grecaptcha.ready(() => resolve(window.grecaptcha)));
    }
    if (loadPromise) { return loadPromise; }
    loadPromise = new Promise((resolve, reject) => {
        const callbackName = `ccRecaptchaLoaded_${Date.now()}`;
        window[callbackName] = () => {
            delete window[callbackName];
            resolve(window.grecaptcha);
        };
        const script = document.createElement('script');
        const render = v3SiteKey ? encodeURIComponent(v3SiteKey) : 'explicit';
        script.src = `https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=${render}`;
        script.async = true;
        script.defer = true;
        script.onerror = () => {
            delete window[callbackName];
            loadPromise = undefined;
            reject(new Error('Unable to load reCAPTCHA'));
        };
        document.head.appendChild(script);
    });
    return loadPromise;
};

const executeV3 = async (siteKey, action) => {
    const grecaptcha = await loadRecaptcha(siteKey);
    return grecaptcha.execute(siteKey, { action });
};

export const getRecaptchaHeaders = async (config, action, v2Token = '') => {
    if (v2Token) { return { 'X-Recaptcha-V2-Token': v2Token }; }
    if (!config?.enabled || !config.v3SiteKey) { return {}; }
    try {
        return { 'X-Recaptcha-V3-Token': await executeV3(config.v3SiteKey, action) };
    } catch {
        return {};
    }
};

export const getRecaptchaChallenge = (error, config) => {
    const code = error?.response?.data?.code;
    if (code !== 'RECAPTCHA_V2_REQUIRED' && code !== 'RECAPTCHA_FAILED') { return null; }
    return {
        code,
        siteKey: error.response?.data?.recaptcha?.siteKey || config?.v2SiteKey || '',
        attempt: Date.now(),
    };
};
